import React, {useEffect, useState} from 'react';
import SubscriptionBox from '../../components/Subscription/SubscriptionBox';
import ExpandLeft from '../../assets/icons/ExpandWhiteLeft';
import { history } from '../../utils';
import HeroImage from "../../assets/icons/svgicons/SubscriptionHeroImage.svg"
import SubscriptionModal from '../../components/Subscription/SubscriptionModal';
import { subscription, useSubscriptionStore } from '../../state/useSubscriptionStore';
import {useUserStore} from "../../state/useUserStore"
import PageLoader from '../../components/common/PageLoader';
import { createSubscription } from '../../backend-services/subscription';


const SubscriptionPage: React.FC = () => {

    const [selectedProvider, setSelectedProvider] = useState<'paystack' | 'flutterwave' | null>(null);
    const [price, setPrice] = useState<number>(0);
    const [email, setEmail] = useState<string>(''); 
    const [companyId, setCompanyId] = useState<number>(0)
    const[subscriptionId, setSubscriptionId] = useState<number>(0)
    const[plan, setPlan] = useState<string>("")
    const [showSubscriptionModal, setShowSubscriptionModal] = useState<boolean>(false)
    const[isChoosing, setIsChoosing] = useState<boolean>(false)
    
 
    const handleHideModal = () => {
      setShowSubscriptionModal(false)
    }

    const { subscriptionList ,fetchListSubscription, isLoading}  = useSubscriptionStore(
         ( state ) => ({
        subscriptionList: state.subscriptionList,
        fetchListSubscription: state.fetchListSubscription,
        isLoading: state.isLoading,
    })
    )
const handleShowModal = async ( plan: string, price: number ) => {
       setIsChoosing(true)
        const subscriptionData = await createSubscription({ plan })
        if(subscriptionData) {
          setShowSubscriptionModal(true) 
          setPrice(price)
          setPlan(plan)
          setSubscriptionId(subscriptionData.id)
          setIsChoosing(false)
        }
       
    }


    const { user, fetchUser } = useUserStore( (state) => ({
       user: state.user,
       fetchUser: state.fetchUserProfile
    }))

    useEffect( () => {
      fetchListSubscription()
      setEmail(user.email)
      setCompanyId(user.id)
    },[fetchListSubscription, user])

  
    useEffect( () => {
    fetchUser()
    },[fetchUser])

    
    return (
        <div className="relative min-h-full lg:bg-contain bg-no-repeat" style={{ backgroundImage: `url(${HeroImage})`}}>
        <div className='flex flex-row pl-[20px]  md:pl-[115px] pt-[64px] text-[#fff]'>
          <span className=''><ExpandLeft/></span>
            <a href='/dashboard' onClick={history.back}>
                <span className=''>Go Back</span>
            </a>
        </div>
            
       
        <div className='flex flex-col lg:min-h-screen items-center justify-center'>
            <div className='mt-[41px] md:mt-[150px] lg:mt-[135px] mb-[54px] md:mb-[172px] lg:mb-0 text-center space-y-[16px] lg:space-y-[18px]'>
              <h1 className="text-[24px] max-w-[335px] md:max-w-full md:text-3xl font-bold text-[#fff]">Improve Your Business Processes Now.</h1>
                <h2 className="text-[16px] max-w-[335px] md:max-w-full md:text-2xl text-[#fff]">Choose your preferred subscription plan</h2>   
            </div>

            {subscriptionList === undefined ? <PageLoader/> :

            <div className="grid gap-[20px] grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:pt-[77px]">
                {Object.values(subscriptionList as unknown as subscription)?.map((plan, index) => (
                    <SubscriptionBox
                        key={plan.name}
                        title={plan.name}
                        limits={plan.limits}
                        price={plan.price}
                        Level={["Start free trial", "Choose this plan", "Choose this plan"]}
                        isPopular={index === 1}
                        index={index}
                        show={handleShowModal}
                        isChoosing={isChoosing}
                    />
                ))}
            </div>
            } 
        </div>
            
        {showSubscriptionModal && (
          <SubscriptionModal
            price={price}
            email={email}
            companyId={companyId}
            plan={plan}
            subscriptionId={subscriptionId}
            close={handleHideModal}
          />
       )}
        </div>
    );
};

export default SubscriptionPage